import { useEffect } from 'react';
import useAccountConfig from '../../hooks/useAccountConfig';
const HOME_PAGE_URL = '/Home.aspx';
function Authorization({ requiredAdminLevel, requiredEmployeeType, children }) {
    const { accountConfig } = useAccountConfig();
    useEffect(() => {
        const meetsRequiredAdminLevel = !requiredAdminLevel || requiredAdminLevel.includes(accountConfig.UIFlags.EmpAdminLevel);
        const meetsRequiredEmployeeType = !requiredEmployeeType || requiredEmployeeType.includes(accountConfig.Emp.EmpType);
        if (!meetsRequiredAdminLevel || !meetsRequiredEmployeeType) {
            window.location.href = HOME_PAGE_URL;
        }
    }, [requiredAdminLevel, requiredEmployeeType, accountConfig]);
    return { ...children };
}
Authorization.defaultProps = {
    requiredAdminLevel: null,
    requiredEmployeeType: null
};
export default Authorization;
